import type * as React from 'react';
import { motion } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';

const PromptBarBorder = styled(motion.div)`
  width: 100%;
  flex: none;
  position: relative;
  color: ${({ theme }) => theme.appUI.magic.primaryColor};
  border-radius: 54px;

  background:
    linear-gradient(
        ${({ theme }) => theme.backgroundColor},
        ${({ theme }) => theme.backgroundColor}
      )
      padding-box,
    linear-gradient(
        180deg,
        ${({ theme }) => rgba(theme.appUI.magic.secondaryColor, 0.7)} 0%,
        ${({ theme }) => rgba(theme.appUI.magic.secondaryColor, 0.3)} 100%
      )
      border-box;

  box-shadow:
    0 0 0 1px ${({ theme }) => rgba(theme.appUI.magic.primaryColor, 0.4)},
    0px 3px 20px 5px rgba(0, 0, 0, 0.3);
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 4px;
  background: ${({ theme }) => theme.appUI.magic.backgroundGradient};
`;

export const PromptBarContainer = ({
  children,
  ...props
}: Omit<React.ComponentPropsWithoutRef<typeof motion.div>, 'children'> & {
  children: React.ReactNode;
}) => {
  return (
    <PromptBarBorder {...props}>
      <Contents>{children}</Contents>
    </PromptBarBorder>
  );
};
